'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useOptimistic } from 'react';
import { CartModal } from './modal';
import { cartReconciler } from './optimistic-utils';
const CartContext = createContext({});
export function useCartContext() {
  return useContext(CartContext);
}
export function CartProvider(t0) {
  const $ = _c(16);
  const {
    children,
    cart
  } = t0;
  const [optimisticCart, updateOptimisticCart] = useOptimistic(cart, cartReconciler);
  let t1;
  if ($[0] !== updateOptimisticCart) {
    t1 = function updateCartItem(merchandiseId, updateType) {
      updateOptimisticCart({
        type: "UPDATE_ITEM",
        payload: {
          merchandiseId,
          updateType
        }
      });
    };
    $[0] = updateOptimisticCart;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updateCartItem = t1;
  let t2;
  if ($[2] !== updateOptimisticCart) {
    t2 = function addCartItem(variant, product, t3) {
      const quantity = t3 === undefined ? 1 : t3;
      updateOptimisticCart({
        type: "ADD_ITEM",
        payload: {
          variant,
          product,
          quantity
        }
      });
    };
    $[2] = updateOptimisticCart;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const addCartItem = t2;
  let t3;
  if ($[4] !== optimisticCart?.lines) {
    t3 = function totalQuantity() {
      return optimisticCart?.lines?.reduce(_temp, 0) ?? 0;
    };
    $[4] = optimisticCart?.lines;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const totalQuantity = t3;
  let t4;
  if ($[6] !== addCartItem || $[7] !== optimisticCart || $[8] !== totalQuantity || $[9] !== updateCartItem) {
    t4 = {
      cart: optimisticCart,
      updateCartItem,
      addCartItem,
      totalQuantity
    };
    $[6] = addCartItem;
    $[7] = optimisticCart;
    $[8] = totalQuantity;
    $[9] = updateCartItem;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children) {
    t5 = <CartModal>{children}</CartModal>;
    $[11] = children;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <CartContext.Provider value={t4}>{t5}</CartContext.Provider>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(acc, line) {
  return acc + line.quantity;
}